<template>
    <div class="row row-middle row-full row-collapse">
        <div class="columns ps--r">
            <featured-products v-bind:items="items"></featured-products>
        </div>
    </div>
</template>
<script>
    import Block from './Block.vue';
    import FeaturedProducts from '../../../FeaturedProducts.vue';

    export default {
        extends: Block,
        components: {
            FeaturedProducts
        },
        data() {
            return {
                items: _.get(this.block.data, 'items', [])
            }
        }
    }
</script>